import {ObjectUtil} from '../util/object-util';

export class ProposalNumber {
    all: number = null;
    favorites: number = null;
    privates: number = null;
    hasOffers: number = null;
    offerSubmitted: number = null;
    rejectedProposals: number = null;
    retractedProposals: number = null;
    retractedOffers: number = null;
    expired: number = null;
    myProposals: number = null;
    onlySubstitutes: number = null;

    constructor(object?: any) {
        ObjectUtil.assign(this, object);
    }
}
